import React from "react";
import { TextField, Autocomplete, MenuItem } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import { tokens } from "../theme";
import { useTheme } from "@mui/material";

const styles = {
  AutocompleteDefaultStyles: { m: 1, width: "20%" },
  ChipStyles: (colors) => ({
    bgcolor: colors.green[700],
    opacity: 0.8,
    fontWeight: 700,
  }),
  MenuItemSyles: {
    justifyContent: "space-between",
    whiteSpace: "normal",
    wordBreak: "break-word",
  },
  // Size the dropdown to its content so long options aren't clipped by the
  // (possibly narrow) input width.
  PopperProps: {
    placement: "bottom-start",
    style: { width: "fit-content", minWidth: "160px", maxWidth: "480px" },
  },
};

const MultiSelect = ({
  allItems,
  setSelectedItems,
  limit = -1,
  label = "",
  sx,
  textFieldProps = {},
  chipSx = { height: "19px" },
  populateItemsWhenEmpty = true,
  defaultChipStyle = false,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.paletteId);
  return (
    <Autocomplete
      sx={sx || styles.AutocompleteDefaultStyles}
      multiple
      limitTags={limit}
      options={allItems || []}
      getOptionLabel={(option) => option}
      disableCloseOnSelect
      onChange={(event, value) => {
        if (setSelectedItems) {
          setSelectedItems(
            !populateItemsWhenEmpty || value?.length ? value : allItems
          );
        }
      }}
      ChipProps={
        defaultChipStyle
          ? { size: "small" }
          : { sx: { ...styles.ChipStyles(colors), ...chipSx } }
      }
      componentsProps={{ popper: styles.PopperProps }}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          label={label}
          {...textFieldProps}
        />
      )}
      renderOption={(props, option, { selected }) => (
        <MenuItem
          {...props}
          key={option}
          value={option}
          sx={styles.MenuItemSyles}
        >
          {option}
          {selected ? <CheckIcon color="info" /> : null}
        </MenuItem>
      )}
    />
  );
};

export default MultiSelect;
